import { patchApi } from '../api'

export async function updatePreferences(params: { want_to_create: string[]; current_time_zone: string }) {
  const { data } = await patchApi('/api/internal/onboarding/preferences', { preferences: params })
  return data
}
